<template>
  <div class="illustrations-content" id="identidade-visual-ilustracao-ilustracoes" data-search-anchor>
    <h1 class="illustrations-title-span">{{ illustrationsTitle }}</h1>  
    
    <template v-for="(block, index) in contentBlocks">
      <div v-if="block.type === 'image'" :key="'image-' + index" class="illustration-img">
        <img :src="block.src" :alt="block.alt" class="illustrations-img" loading="lazy" />
      </div>
      <div
        v-else-if="block.type === 'text'"
        :key="'text-' + index"
        class="illustrations-text"
        :class="block.className"
      >
        <p v-if="block.title" class="fica-a-dica">{{ block.title }}</p>
        <p v-if="block.text">{{ block.text }}</p>
      </div>
    </template>
   
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { applyHighlightAndWatch } from '@/core/searchHighlight'

interface ContentBlock {
  type: 'image' | 'text'
  
  src?: string
  alt?: string
  
  title?: string
  text?: string
  className?: string
}

@Component({})
export default class IllustrationSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  get illustrationsTitle(): string {
  return this.getElementTitle(8, 0)
  }
  
  get contentBlocks(): ContentBlock[] {
    const pageId = 8
    return [
      { type: 'image', src: this.getElementMedia(pageId, 1), alt: 'sutentabilidade' },
      { type: 'image', src: this.getElementMedia(pageId, 2), alt: 'sutentabilidade' },
      { type: 'image', src: this.getElementMedia(pageId, 3), alt: 'bem-estar' },
      { type: 'text', title: this.getElementTitle(pageId, 4), text: this.getElementText(pageId, 4), className: 'text-margin-top' },
      { type: 'image', src: this.getElementMedia(pageId, 5), alt: 'Brasilidade' },
      { type: 'image', src: this.getElementMedia(pageId, 6), alt: 'Diversidade' },
      { type: 'image', src: this.getElementMedia(pageId, 7), alt: 'Conectividade' },
      { type: 'image', src: this.getElementMedia(pageId, 8), alt: 'Comunicação' },
      { type: 'text', title: this.getElementTitle(pageId, 9), text: this.getElementText(pageId, 9) },
      { type: 'image', src: this.getElementMedia(pageId, 10), alt: 'Celebração' },
      { type: 'image', src: this.getElementMedia(pageId, 11), alt: 'Criação' },
      { type: 'text', title: this.getElementTitle(pageId, 12), text: this.getElementText(pageId, 12) },
      { type: 'image', src: this.getElementMedia(pageId, 13), alt: 'Jornalismo' },
      { type: 'image', src: this.getElementMedia(pageId, 14), alt: 'Estúdio' },
      { type: 'image', src: this.getElementMedia(pageId, 15), alt: 'Ficção' },
      { type: 'image', src: this.getElementMedia(pageId, 16), alt: 'Reunião' },
      { type: 'text', title: this.getElementTitle(pageId, 17), text: this.getElementText(pageId, 17) },
      { type: 'image', src: this.getElementMedia(pageId, 18), alt: 'Consumidores' },
      { type: 'image', src: this.getElementMedia(pageId, 19), alt: 'Avatares' },
    ]
  }

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
    const query = (this.$route.query.q as string) || ''
    if (query) {
      this.$nextTick(() => {
        applyHighlightAndWatch(query)
      })
    }
  }
}
</script>

<style lang="scss">
.illustrations-content {
  max-width: 1032px;  
  display: flex;
  flex-direction: column;  
}

.illustrations-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #b3b3b3;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
  margin: 0
}

.illustrations-img {
  width: 100%;
  height: 580px;
  object-fit: cover;
}

.illustrations-text {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;  
  max-width: 430px;  
}

.text-margin-top {
  margin-top: 2rem;
}

@media (min-width: 1726px) {
  .illustrations-content {
    width: 100%;
  }
}
</style>
